import { bind } from '@react-rxjs/core';
import { createSignal } from '@react-rxjs/utils';
import { asyncScheduler, concat, concatMap, delay, delayWhen, of, race, timer } from 'rxjs';

export type NoticeObject = {
  message: string;
  timer?: number;
  variant?: 'primary' | 'error' | 'success' | 'warning' | 'info';
};

const ANIMATION_DELAY = 600;
const DEFAULT_NOTICE_DURATION = 10000;

export const [noticeQueue$, queueNotice] = createSignal<NoticeObject>();
export const [skipNotice$, skipNotice] = createSignal<void>();

const notice$ = noticeQueue$.pipe(
  concatMap((notice) =>
    concat(
      of(['show', notice] as const),
      of(['hide', notice] as const).pipe(
        delayWhen(() => race(timer(notice.timer ?? DEFAULT_NOTICE_DURATION, asyncScheduler), skipNotice$))
      ),
      of(['reset'] as const).pipe(delay(ANIMATION_DELAY))
    )
  )
);

export const [useNotice] = bind(notice$, ['reset'] as const);
